/**
 * Client-side Google Ads tracking utilities for gclid capture and cookie reading.
 * Used to enrich Segment track calls with Google Ads attribution data.
 * Mirrors the Meta (fbclid) tracking pattern in meta_tracking_client.ts.
 */

/**
 * Capture gclid from URL search params and store as _gcl_aw cookie.
 * Google uses this to attribute conversions back to ad clicks.
 * Format: GCL.{version}.{timestamp}.{gclid}
 * No-op if gclid param is absent.
 */
export function captureGclid(): void {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const gclid = params.get('gclid');

  if (gclid) {
    const timestamp = Date.now();
    const value = `GCL.1.${timestamp}.${gclid}`;
    const expires = new Date(
      Date.now() + 90 * 24 * 60 * 60 * 1000
    ).toUTCString();
    document.cookie = `_gcl_aw=${value};expires=${expires};path=/;`;
  }
}

/**
 * Read gclid from the _gcl_aw cookie.
 * Returns the raw gclid value (stripped from cookie format), or undefined.
 */
export function getGclid(): string | undefined {
  if (typeof document === 'undefined') return undefined;

  const match = document.cookie.match(/(?:^|;\s*)_gcl_aw=([^;]*)/);
  if (!match) return undefined;

  // Cookie format: GCL.1.{timestamp}.{gclid} — extract the gclid portion
  const parts = match[1].split('.');
  return parts.length >= 4 ? parts.slice(3).join('.') : match[1];
}
